<template>
    <div class="row justify-content-center g-4">
        <div v-for="(item, index) in featuredProviders" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <GridLayout2 :item="item" :border="border"/>
        </div>
    </div>
</template>

<script setup>
    import {defineProps,ref,onMounted,watch} from 'vue'
    import axios from "axios";
    import GridLayout2 from './grid-layout2.vue';
    import { useI18n } from "vue-i18n";
    const { locale } = useI18n();

    defineProps({
        border:Boolean
    })
    const featuredProviders = ref([])
    const fetchFeaturedProviders = async () => {
    try {
        const res = await axios.get("/users/list-service-provider?featured=featured", {
            headers: {
                'locale': locale.value
            }
        });

        const featured = res.data.service_providers;

        featuredProviders.value = featured.slice(0, 6);


    } catch (error) {
        console.error('Error fetching featured providers:', error);
    }
    };
    onMounted(() => {
    fetchFeaturedProviders();
    });
    watch(locale, () => {
        fetchFeaturedProviders();
    });
</script>
